import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../../rootReducer';
import { ContentTypes, HttpError, HttpMethods, SERVICES } from '../../../services/api';
import { showErrorMessage } from '../../notifications';
import { ListParams } from '../../utils';
import { FilterOperators, Ifilter } from '../../../components/common/filters/interfaces';
import { fetchAccountsList } from '../list.thunks';
import { IAddEnterpriseSeatsDTO } from './interfaces';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';

export const ADD_ENTERPRISE_SEATS_THUNK_PREFIX = 'account/addEnterpriseSeats';
export const addEnterpriseSeats: AsyncThunk<void, IAddEnterpriseSeatsDTO, ThunkAPI> = createAsyncThunk(
  ADD_ENTERPRISE_SEATS_THUNK_PREFIX,
  async (data: IAddEnterpriseSeatsDTO, thunk) => {
    if (!isFeatureEnabled(Features.TrialsOfTiers) && !isFeatureEnabled(Features.BillingUserFacing)) {
      thunk.dispatch({
        type: 'DO_NOTHING'
      });
      return;
    }
    try {
      const additionalData = isFeatureEnabled(Features.BillingUserFacing) ? { carbonCopyRecipients: data.carbonCopyRecipients } : {};
      const response = await basicApiAsyncThunkCreator<void, IAddEnterpriseSeatsDTO>({
        endpoint: 'accounts/enterprise/seats-addition',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: ContentTypes.ApplicationJson
      })({
        accountId: data.accountId,
        numberOfSeats: data.numberOfSeats,
        invoiceNotes: data.invoiceNotes,
        ...additionalData
      }, thunk);
      const fetchAccountsRequest: ListParams<Ifilter[]> = {
        filters: [
          {
            field: '_id',
            operands: [data.accountId],
            operator: FilterOperators.isAnyOf,
            validateInputs: false
          }
        ]
      };
      thunk.dispatch(fetchAccountsList(fetchAccountsRequest));
      return response;
    } catch (err) {
      let errorMessage = 'An error occurred while adding seats';
      if (err instanceof Error || err instanceof HttpError) {
        errorMessage = err.message || errorMessage;
      }
      thunk.dispatch(showErrorMessage(errorMessage));
      return thunk.rejectWithValue(errorMessage);
    }
  }
);